import { render, staticRenderFns } from "./ListProcedures.vue?vue&type=template&id=0f3a1eee&"
import script from "./ListProcedures.vue?vue&type=script&lang=js&"
export * from "./ListProcedures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports